/** Vite dev server, or explicit opt-in via VITE_ENABLE_DEV_LOGIN. */
export function isDevMode(): boolean {
  return import.meta.env.DEV || import.meta.env.VITE_ENABLE_DEV_LOGIN === "true";
}
